import React from "react";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">
        <div className="static-header">
          <h1 className="container">Privacy Policy</h1>
        </div>
        <div className="container mt-3">
          <p>
            <b>Effective Date: </b>
            <br />
            <b>Last Updated: </b>
          </p>
          <p className="mb-4">
            This Privacy Policy (“Policy”) describes how{" "}
            <b>AVANAD TECHPROSERVE</b>
            ("we", "our", or "us") collects, uses, discloses, and protects your
            personal information through our platform <b>UpskillMeet</b>,
            available at{" "}
            <a href="https://techproserve.com">https://techproserve.com</a>, and
            associated services (the "Platform")
          </p>
          <p>
            By accessing or using the Platform, you agree to the collection and
            use of your information in accordance with this Policy.
          </p>
          <hr />
        </div>

        <div className="container">
          <p>
            <b>1. Information We Collect</b>
          </p>
          <p>
            We collect information that you provide directly, information we
            collect automatically, and information from third-party
            integrations.
          </p>
          <p>
            <b>a. Information You Provide</b>
          </p>
          <p>
            We may collect the following information when you register, offer
            services, book a session, or communicate with us:
          </p>
          <ul>
            <li>Full Name</li>
            <li>Email Address</li>
            <li>Phone Number (internal use only, not displayed to public)</li>
            <li>
              WhatsApp Number (internal use only, not displayed to public)
            </li>
            <li>
              Education Details (e.g., degree, institution, year – optional)
            </li>
            <li>
              Professional Experience (e.g., company name, job title, years –
              optional)
            </li>
            <li>
              Social Media Links (LinkedIn, Instagram, etc. – optional, used to
              showcase expertise)
            </li>
            <li>Biography and Profile Image</li>
            <li>Booking and Session History</li>
            <li>
              Bank Account Details (Account number, IFSC code, Account Holder
              Name) – Required for mentors/service providers to receive payouts.
              Stored securely and not shared publicly.
            </li>
          </ul>

          <p>
            <b>b. Transaction Information</b>
          </p>
          <ul>
            <li>Billing Address</li>
            <li>Order and Booking Details</li>
            <li>
              Payment Information (processed via Razorpay; we do not store card
              details)
            </li>
          </ul>

          <p>
            <b>c. Automatically Collected Information</b>
          </p>
          <p>When you use our Platform, we may collect:</p>
          <ul>
            <li>IP Address</li>
            <li>Device Type and Identifiers</li>
            <li>Browser Type and Language</li>
            <li>Time Zone</li>
            <li>Pages Visited, Session Duration, Click Behavior</li>
            <li>Referring Website or Source</li>
            <li>Cookies and Similar Tracking Technologies</li>
          </ul>

          <p>
            <b>d. Google Calendar Integration</b>
          </p>
          <p>If you authorize Google Calendar access, we may:</p>
          <ul>
            <li>Read your calendar to check availability</li>
            <li>Add or modify events to sync booking schedules</li>
            <li>Delete events if bookings are canceled</li>
          </ul>
          <p>
            We do not use calendar data for any purpose other than scheduling.
            We fully comply with the Google API Services User Data Policy,
            including Limited Use requirements.
          </p>
          <hr />

          <p>
            <b>2. How We Use Your Information</b>
          </p>
          <p>We use your information to:</p>
          <ul>
            <li>Register and manage your UpskillMeet account</li>
            <li>
              Connect you with experts/mentors, mentees, or service providers
            </li>
            <li>Process session bookings and payments via Razorpay</li>
            <li>Handle payouts to expert/mentors/service providers</li>
            <li>Send booking confirmations, reminders, and support updates</li>
            <li>Personalize and improve the Platform experience</li>
            <li>Detect and prevent fraud, abuse, or technical issues</li>
            <li>Comply with legal obligations and platform policies</li>
          </ul>
          <p>
            We do not use your phone number or WhatsApp number for marketing
            purposes. These are used strictly for account verification, support,
            and internal coordination.
          </p>
          <hr />

          <p>
            <b>3. Legal Basis for Processing</b>
          </p>
          <p>We process your data:</p>
          <ul>
            <li>With your consent</li>
            <li>
              To fulfill contractual obligations (e.g., booking sessions,
              sending payments)
            </li>
            <li>To comply with legal and regulatory obligations</li>
            <li>
              For our legitimate interests, such as improving the platform or
              fraud prevention
            </li>
          </ul>
          <hr />

          <p>
            <b>4. Sharing of Information</b>
          </p>
          <p>
            We do not sell your personal information. We may share data only
            with:
          </p>
          <p>
            <b>a. Authorized Third Parties:</b>
          </p>
          <ul>
            <li>Razorpay – Payment processing</li>
            <li>MongoDB Atlas – Cloud database hosting</li>
            <li>Google APIs – Calendar sync functionality</li>
            <li>Analytics tools – Performance monitoring and improvement</li>
          </ul>
          <p>
            All third-party vendors are bound by contractual agreements to
            protect your data and use it only for service delivery.
          </p>
          <p>
            <b>b. Legal Authorities:</b>
          </p>
          <p>
            We may disclose your information where required to comply with
            applicable laws, enforce our policies, or respond to lawful requests
            by public authorities.
          </p>
          <hr />

          <p>
            <b>5. Data Retention</b>
          </p>
          <p>We retain your information for as long as necessary:</p>
          <ul>
            <li>To provide services and support</li>
            <li>To comply with legal, accounting, or reporting obligations</li>
            <li>To enforce our terms and resolve disputes</li>
          </ul>
          <p>
            If you wish to delete your information, you can request this via the
            contact details below.
          </p>
          <hr />

          <p>
            <b>6. Data Security</b>
          </p>
          <p>We employ industry-standard security measures, including:</p>
          <ul>
            <li>SSL encryption</li>
            <li>Role-based access controls</li>
            <li>Secure cloud infrastructure via MongoDB Atlas</li>
            <li>
              Encrypted storage for sensitive details like bank account
              information
            </li>
            <li>
              Razorpay's PCI-DSS-compliant environment for payment processing
            </li>
          </ul>
          <p>
            Despite our efforts, no method of transmission over the internet is
            100% secure.
          </p>
          <hr />

          <p>
            <b>7. Cookies and Tracking Technologies</b>
          </p>
          <p>We use cookies and similar technologies to:</p>
          <ul>
            <li>Recognize your browser</li>
            <li>Maintain session integrity</li>
            <li>Improve site performance and personalization</li>
          </ul>
          <p>
            You may disable cookies in your browser settings, but certain
            features of the Platform may not function optimally.
          </p>
          <hr />

          <p>
            <b>8. Children's Privacy</b>
          </p>
          <p>
            Our services are open to individuals of all ages, including
            students. However, we are committed to protecting the privacy of
            minors.
          </p>
          <p>
            If you are under the age of 18, you must use the Platform under the
            supervision of a parent or legal guardian.
          </p>
          <p>
            We do not knowingly collect personal information from children
            without appropriate consent.
          </p>
          <p>
            If we learn that we have collected personal data from a minor
            without verified parental consent where required, we will take steps
            to delete such information promptly.
          </p>
          <hr />

          <p>
            <b>9. Your Rights</b>
          </p>
          <p>As a user, you have the right to:</p>
          <ul>
            <li>Access the personal data we hold about you</li>
            <li>Correct inaccurate or outdated information</li>
            <li>Delete your data</li>
            <li>Withdraw consent (where applicable)</li>
            <li>Object to or restrict certain data processing activities</li>
          </ul>
          <p>
            To exercise these rights, contact us at contactus@techproserve.com.
          </p>
          <hr />

          <p>
            <b>10. Do Not Track Signals</b>
          </p>
          <p>
            Our Platform does not currently respond to "Do Not Track" browser
            signals.
          </p>
          <hr />

          <p>
            <b>11. Changes to This Privacy Policy</b>
          </p>
          <p>
            We may revise this Policy from time to time. Updates will be posted
            on this page with a new effective date. Continued use of the
            Platform implies acceptance of the revised policy.
          </p>
          <hr />

          <p>
            <b>12. Grievance Redressal</b>
          </p>
          <p>
            If you have any concerns or grievances about this Privacy Policy or
            our data practices, please reach out to our Grievance Officer:
          </p>
          <p>
            Grievance Officer: Gauthami
            <br />
            Email:{" "}
            <a href="mailto:contactus@techproserve.com">
              contactus@techproserve.com
            </a>{" "}
            d
            <br />
            Address: G2-F1, VGN Minerva, Nolambur, Mogappair West, Chennai –
            600095, Tamil Nadu, India
          </p>
          <hr />

          <p>
            <b>13. Contact Information</b>
          </p>
          <p>
            Company: AVANAD TECHPROSERVE
            <br />
            CIN: U62012TN2024PTC169095
            <br />
            Website:{" "}
            <a href="https://techproserve.com">https://techproserve.com</a>
            <br />
            Email:{" "}
            <a href="mailto:contactus@techproserve.com">
              contactus@techproserve.com
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
